import React from 'react'
import Loading from 'src/components/Loading'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'

import { Wrapper, Container, TextWrap, Title, Text, Image } from './style'

export default function NascemosParaFacilitar() {
	const { data, isLoading } = useFetchContent()

	if (isLoading || !data) return <Loading />

	const {
		title,
		description,
		background,
		textColor,
		image
	} = getSection({ sectionName: 'landingSimpleSection', data })


	return (
		<Wrapper style={{ backgroundColor: background }}>
			<Container>
				<TextWrap>
					<Title color={textColor}>{title}</Title>
					<Text color={textColor}>{description}</Text>
				</TextWrap>
				<Image src={`https://${image.fields.file.url}`} />
			</Container>
		</Wrapper>
	)
}
